export const fiftyAmpSitePictures = [
  {
    display_name: `Site 83`,
    location: require("./fifty_amp_site_pictures/50Amp_premium_83.webp"),
  },
  {
    display_name: `Site 84`,
    location: require("./fifty_amp_site_pictures/50Amp_premium_84.webp"),
  },
  {
    display_name: `Site 85`,
    location: require("./fifty_amp_site_pictures/50Amp_premium_85.webp"),
  },
  {
    display_name: `Site 85 and 86`,
    location: require("./fifty_amp_site_pictures/50Amp_premium_85_86.jpg"),
  },
  {
    display_name: `Site 86`,
    location: require("./fifty_amp_site_pictures/50Amp_premium_86.jpg"),
  },
  {
    display_name: `Site 87`,
    location: require("./fifty_amp_site_pictures/50Amp_premium_87.jpg"),
  },
];
